import React from 'react';

export default function Tools() {
  return (
    <div>
      <h1 className="h4 mb-3">Tools Management</h1>
      <p className="text-muted">Manage tools here.</p>
    </div>
  );
}
